import React, { useRef } from 'react';
import { Search, X } from './icons';
export function SyntaxHelpSearch({ searchQuery, onSearchChange, }) {
    const inputRef = useRef(null);
    const handleClear = () => {
        onSearchChange('');
        if (inputRef.current) inputRef.current.focus();
    };
    return (<div className="syntax-sidebar-search-box">
      <Search size={15} className="syntax-sidebar-search-icon" aria-hidden="true"/>
      <input ref={inputRef} type="text" className="syntax-sidebar-search-input" placeholder="Search syntax..." value={searchQuery} onChange={(e) => onSearchChange(e.target.value)} aria-label="Search syntax"/>
      {searchQuery.trim() !== '' && (<button type="button" className="syntax-sidebar-search-clear" onClick={handleClear} title="Clear search" aria-label="Clear search query">
          <X size={13}/>
        </button>)}
    </div>);
}
